(function () {
  if (window.__ctrIconWithTextInit) return;
  window.__ctrIconWithTextInit = true;

  function getSelectedPurchaseOption(scope) {
    var root = scope || document;
    var selected =
      root.querySelector('[data-ctr-purchase-option]:checked') ||
      root.querySelector('[data-legacy-purchase-option]:checked');
    return selected ? selected.value : null;
  }

  function syncIconWithText(scope) {
    var searchRoot = scope || document;
    var blocks = searchRoot.querySelectorAll('[data-ctr-icon-with-text]');
    if (!blocks.length && searchRoot.matches && searchRoot.matches('[data-ctr-icon-with-text]')) {
      blocks = [searchRoot];
    }

    blocks.forEach(function (block) {
      var sectionRoot = block.closest('.shopify-section') || document;
      var selectedOption = getSelectedPurchaseOption(sectionRoot);
      var hasVisible = false;

      block.querySelectorAll('[data-ctr-show-for]').forEach(function (item) {
        var showFor = item.getAttribute('data-ctr-show-for') || 'both';
        var visible = !selectedOption || showFor === 'both' || showFor === selectedOption;
        item.classList.toggle('is-hidden', !visible);
        if (visible) hasVisible = true;
      });

      block.classList.toggle('is-hidden', !hasVisible);
    });
  }

  function init(scope) {
    syncIconWithText(scope || document);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('[data-ctr-purchase-option], [data-legacy-purchase-option]')) return;
    syncIconWithText(target.closest('.shopify-section') || document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  window.addEventListener('pageshow', function () {
    init(document);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:select', function (event) {
      init(event.target);
    });
  }
})();
